import React, { useState } from "react";
import Layouts from "../../Layouts";
import { IoLocationOutline, IoTrashOutline } from "react-icons/io5";
import CartBackground from "../../../Assests/images/CartBackground.png";
import Counter from '../../../Shared/Counter';
import { useDispatch, useSelector } from "react-redux";
import { setIncreaseItemQTY, setDecreaseItemQTY, selectTotalAmount, setRemoveItemFromCart, setClearCartItems } from "../../../app/CartSlice";
import { useNavigate } from "react-router-dom";
// import { BsArrowLeft } from "react-icons/bs";
import Address from "../CartPage/Address";
import { Drawer, Input, Modal, Radio } from "antd";
import { TiPlus } from "react-icons/ti";
import { isAuthenticated } from "../../../utils/auth";
import LoginModal from "../../../Shared/LoginModal";


function CartPage() {
  const state = useSelector(state => state.cart.cartItems) || [];
  const cartTotal = useSelector(state => state.cart.cartTotalAmount) || 0;
  const dispatch = useDispatch();
  const deliveryCharge = state.length > 0 ? 20 : 0;
  const navigate = useNavigate();

  const subTotal = state.reduce((acc, it) => {
    const p = Number(it.selectedProductPrice ?? it.price ?? 0);
    const q = Number(it.cartQuantity) || 1;
    return acc + p * q;
  }, 0);

  const finalTotal = subTotal > 0 ? subTotal + deliveryCharge : 0;

  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isOrderPlacedModalOpen, setIsOrderPlacedModalOpen] = useState(false);

  const handleProceedToPay = () => {
    if (isAuthenticated()) {
      setIsOrderPlacedModalOpen(true);
    } else {
      setIsLoginModalOpen(true);
    }
  };

  const handleLoginSuccess = () => {
    setIsLoginModalOpen(false);
    setIsOrderPlacedModalOpen(true);
  };

  const handleOrderPlacedModalClose = () => {
    dispatch(setClearCartItems());
    setIsOrderPlacedModalOpen(false);
    navigate('/product');
  };

  const handleProductsClick = () => {
    navigate('/product');
  };

  const [showAddressModal, setShowAddressModal] = useState(false); // State to control the visibility of the address modal

  const handleClick = (type, id) => {
    if (type === 'increment') {
      dispatch(setIncreaseItemQTY(id));
    } else if (type === 'decrement') {
      dispatch(setDecreaseItemQTY(id));
    }
  };

  const handleItemDelete = (item) => {
    dispatch(setRemoveItemFromCart(item));
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const [selectedValue, setSelectedValue] = useState('');
  const handleRadioChange = (e) => {
    setSelectedValue(e.target.value);
  };

  return (
    <Layouts>
      <div className="bg-white">
        <div className="relative">
          <img
            src={CartBackground}
            alt="cart"
            className="w-full h-52 mt-0 md:mt-8 object-cover"
          />
          <p className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-xl md:text-[50px] font-black text-white">
            My Cart
          </p>
        </div>
        {state.length === 0 ? (
          <div className="flex flex-col gap-4 justify-center items-center h-[50vh]">
            <h1 className="md:text-4xl text-xl font-medium text-productColour">Your Cart is empty</h1>
            <button
              className="border-2 border-popButtoncolour rounded-md bg-[#A17A17] text-white w-[200px] md:w-[250px] md:h-[60px] h-[40px] font-sans font-medium text-lg mt-5 hover:bg-[#85630e] transition-colors"
              onClick={handleProductsClick}
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          <div className="container text-pi md:flex justify-between px-6 gap-5 mt-5 mb-20">
            <div className="md:w-[60%] overflow-hidden">
              {state.map((item, idx) => {
                const itemPrice = Number(item.selectedProductPrice ?? item.price ?? 0);
                const itemQty = Number(item.cartQuantity) || 1;
                const itemTotal = itemPrice * itemQty;
                const sizeLabel =
                  typeof item.selectedSize === "object" && item.selectedSize?.packageSize
                    ? item.selectedSize.packageSize
                    : typeof item.selectedSize === "string"
                    ? item.selectedSize
                    : "Standard";
                const imageSrc = item.imageName
                  ? item.imageName.startsWith("http") || item.imageName.startsWith("data:")
                    ? item.imageName
                    : `${process.env.REACT_APP_IMAGE_URL || ""}${item.imageName}`
                  : item.imageUrl || "";

                return (
                  <div
                    key={item.cartItemId || item.id || idx}
                    className="justify-between md:mb-6 mb-4 rounded-lg border drop-shadow-xl bg-white md:p-6 p-4 sm:flex sm:justify-start"
                  >
                    <img
                      src={imageSrc}
                      alt={item.name || "product"}
                      className="rounded-lg w-48 mx-auto object-contain h-48"
                    />
                    <div className="md:ml-10 flex w-full justify-between">
                      <div className="mt-2 sm:mt-0">
                        <h2 className="md:text-2xl text-xl font-sans font-medium text-gray-900">{item.name}</h2>
                        <h2 className="mt-2 text-lg text-green-900 font-medium">{sizeLabel}</h2>
                        <div className="mt-2">
                          <p className="text-lg font-sans font-semibold text-[#A17A17]">
                            INR {itemPrice}
                            {itemQty > 1 && (
                              <span className="text-sm font-normal text-gray-500 ml-2">
                                (Total: INR {itemTotal})
                              </span>
                            )}
                          </p>
                        </div>
                        <div className="mt-3">
                          <Counter
                            counter={itemQty}
                            handleClick={handleClick}
                            id={item.cartItemId || item.id}
                          />
                        </div>
                      </div>
                      <div className="mt-3 flex justify-between sm:space-y-6 sm:mt-0 sm:block sm:space-x-6">
                        <IoTrashOutline
                          className="text-3xl hover:cursor-pointer text-red-700 hover:text-red-900 transition-colors"
                          onClick={() => handleItemDelete(item)}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="md:w-[30%]">
              <div className="border rounded-lg shadow-md bg-[#FFF0C0] p-3">
                <div className="flex gap-1">
                  <IoLocationOutline className="mt-1 text-[20px]" />
                  <h3 className="text-xl font-medium">Delivery Address</h3>
                </div>
                <hr className="my-1 border-b-2 border-gray-500" />
                <div className="mt-2">
                  <p>Balaji</p>
                  <p>8870558276</p>
                  <p>1/37E,Prevaj Consultants Pvt Ltd,Butt Road, St Thomas Mount, Chennai-600016, Tamilnadu</p>
                </div>
                <div className="flex justify-center items-center">
                  <button
                    className="mt-2 border h-12 w-full mx-4 text-xl font-medium border-popButtoncolour bg-[#A17A17] text-white rounded-lg font-sans hover:bg-[#85630e] transition-colors"
                    onClick={showDrawer}
                  >
                    Change Address
                  </button>
                </div>
              </div>

              <div className="rounded-lg border bg-[#FFF0C0] p-6 mt-8 shadow-md">
                <div className="bg-popUpgreen p-3 flex justify-between items-center">
                  <input placeholder="Avail Coupons" className="p-2 w-full" />
                  <button onClick={showModal} className="border bg-[#A17A17] p-2 rounded-md text-white hover:bg-[#85630e]">
                    Apply
                  </button>
                </div>

                <div className="mb-2">
                  <h2 className="flex justify-center text-xl text-[#404040] font-bold">Cart Total</h2>
                  <div className="mt-3 flex justify-between font-medium">
                    <p className="text-gray-700">Subtotal</p>
                    <p className="text-gray-700 font-semibold">INR {subTotal}</p>
                  </div>
                </div>
                <div className="flex justify-between font-medium">
                  <p className="text-gray-700">Shipping</p>
                  <p className="text-gray-700 font-semibold">INR {deliveryCharge}</p>
                </div>
                <hr className="my-4" />
                <div className="flex justify-between mb-3">
                  <p className="text-lg font-bold">Total</p>
                  <div>
                    <p className="mb-1 text-lg font-bold text-[#A17A17]">INR {finalTotal}</p>
                  </div>
                </div>
                <div className="flex justify-center">
                  <button
                    onClick={handleProceedToPay}
                    className="border rounded w-full p-2 border-popButtoncolour bg-[#A17A17] hover:bg-[#85630e] text-white text-xl font-sans font-medium transition-colors cursor-pointer"
                  >
                    Proceed To Pay
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Login Modal for authentication check on Proceed to Pay */}
        <LoginModal
          isOpen={isLoginModalOpen}
          onClose={() => setIsLoginModalOpen(false)}
          onLoginSuccess={handleLoginSuccess}
        />

        {/* Order Placed Success Modal */}
        <Modal
          open={isOrderPlacedModalOpen}
          onCancel={handleOrderPlacedModalClose}
          footer={null}
          centered
          closable={true}
          maskClosable={false}
          width={450}
          bodyStyle={{ padding: 0 }}
        >
          <div className="flex flex-col items-center text-center p-8 bg-white rounded-3xl">
            {/* Beautiful Success Animation/Icon */}
            <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mb-6 animate-bounce">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2.5}
                stroke="#10B981"
                className="w-10 h-10"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            </div>

            {/* Title */}
            <h2 className="text-2xl font-serif font-black text-gray-900 mb-4 tracking-wide">
              Order Placed Successfully!
            </h2>

            {/* Content */}
            <p className="text-sm md:text-base text-gray-600 font-medium leading-relaxed mb-8 px-2">
              Payment link will be sent to your registered mobile number, make the payment through the link to initiate the delivery process.
            </p>

            {/* Dismiss Button */}
            <button
              onClick={handleOrderPlacedModalClose}
              className="w-full py-3.5 bg-gradient-to-r from-[#A17A17] to-[#B88E28] hover:from-[#8C6913] hover:to-[#A17A17] text-white font-bold text-base rounded-2xl shadow-md hover:shadow-lg transition-all duration-200 transform hover:-translate-y-0.5 active:translate-y-0 cursor-pointer"
            >
              Continue Shopping
            </button>
          </div>
        </Modal>
        <Drawer title={<span className="uppercase text-white">Select Delivery Address</span>} onClose={onClose} open={open}>
          <div>
            <Address visible={showAddressModal} onCancel={() => setShowAddressModal(false)} />
            <div className="flex gap-2">
              <TiPlus className="mt-1" />
              <label className="uppercas cursor-pointer" onClick={() => setShowAddressModal(true)}>Add New Address</label>
            </div>
            <div className="flex border-gray-600 mt-3">
              <div className="w-[10%]">
                <Radio
                  className="cursor-pointer"
                  value="option1"
                  onChange={handleRadioChange}
                  checked={selectedValue === 'option1'}
                >
                </Radio>
              </div>
              <div className="w-[90%]">
                <div className="flex gap-16">
                  <p className="text-base font-medium text-gray-700">Balaji</p>
                  <p className="rounded-full border w-16 text-center bg-popButtoncolour text-white">Home</p>
                </div>
                <p className="text-base font-medium text-gray-700">8870558276</p>
                <p className="text-sm mt-1 text-gray-700">1/37E, Prevaj Consultants Pvt Ltd, Butt Road, St Thomas Mount, Chennai-600016, Tamilnadu</p>


                {selectedValue === 'option1' && (
                  <div className="flex w-full mt-2">
                    <button className="border p-2 w-full rounded-md bg-[#A17A17] text-white font-medium">Deliver to this Address</button>
                  </div>
                )}
              </div>
              <div>Edit</div>
            </div>
            <div className="flex border-gray-600 mt-3">
              <div className="w-[10%]">
                <Radio
                  className="cursor-pointer"
                  value="option"
                  onChange={handleRadioChange}
                  checked={selectedValue === 'option'}
                >
                </Radio>
              </div>
              <div className="w-[90%]">
                <div className="flex gap-16">
                  <p className="text-base font-medium text-gray-700">Balaji</p>
                  <p className="rounded-full border w-16 text-center bg-popButtoncolour text-white">Office</p>
                </div>            <p className="text-base font-medium text-gray-700">8870558276</p>
                <p className="text-sm mt-1 text-gray-700">1/37E, Prevaj Consultants Pvt Ltd, Butt Road, St Thomas Mount, Chennai-600016, Tamilnadu</p>
                {selectedValue === 'option' && (
                  <div className="flex w-full mt-2">
                    <button className="border p-2 w-full rounded-md bg-[#A17A17] text-white font-medium">Deliver to this Address</button>
                  </div>
                )}
              </div>
              <div>Edit</div>
            </div>
          </div>
        </Drawer>
      </div>
    </Layouts>
  );
}

export default CartPage;













